<template>
    <div :class="['ui segment', { inverted: theme }]" :style="segmentStyle">
        <div :class="titleClass">
            <i :class="iconClass"></i>
            {{ title }}
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
  name: 'CardTitle',
  props: {
    title: String,
    titleClass: [String, Array],
    iconClass: String,
    segmentStyle: {
      type: [String, Array],
      default: '',
    },
  },
  data() {
    return {
      theme: localStorage.getItem('theme'),
    };
  },
};

</script>
